import { render } from "./descript.vue?vue&type=template&id=3d13d88a"
import script from "./descript.vue?vue&type=script&lang=js"
export * from "./descript.vue?vue&type=script&lang=js"

import "./descript.vue?vue&type=style&index=0&id=3d13d88a&lang=scss"

import exportComponent from "/builds/feng.chen/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__